import React from "react";

const DivisionInfo = ({
  champions,
  nationals,
  title
}) => {
  return (
    <div className="flex w-full mb-4 flex-col xs:flex-row items-start justify-between pt-2 md:pt-4">
      {/* leader*/}
        <div
            className="w-full flex flex-col w-full border-2 dark:border-0 border-light-3 dark:bg-dark-4 rounded p-2 min-h-24 items-center justify-center max-xs:mb-2">
            <p className="leading-tight text-center font-semibold text-lg md:text-xl mb-2">
                {nationals ? "National Champions" : "Cup Champions"}
            </p>

            {!nationals && champions.cup_name && (
                <div className="flex flex-row items-center justify-center">
                    <img
                        src={champions.cup_img}
                        alt={champions.cup_name}
                        className="mx-1 xs:max-sm:mx-2 sm:mx-4 inline object-cover w-10 h-10 md:w-12 md:h-12"
                    />
                    <div className="flex flex-col items-center justify-center mx-2">
                        <p className="text-sm md:text-xl text-center">{champions.cup_name}</p>
                        <p className="text-xs text-center">{title}</p>
                    </div>
                    <img
                        src={champions.cup_img}
                        alt={champions.cup_name}
                        className="mx-1 xs:max-sm:mx-2 sm:mx-4 inline object-cover w-10 h-10 md:w-12 md:h-12"
                    />
                </div>)}

            {nationals && champions.gold_name && (

                <div className="flex flex-row items-center justify-center">
                    <img
                        src={`https://buiha.org.uk/assets/img/icon/150/${champions.gold_img}.png`}
                        alt={champions.gold_name}
                        className="mx-1 xs:max-sm:mx-2 sm:mx-4 inline object-cover w-10 h-10 md:w-12 md:h-12"
                    />
                    <div className="flex flex-col items-center justify-center mx-2">
                        <p className="text-sm md:text-xl font-light text-center">{champions.gold_name}</p>
                        <p className="text-xs text-center font-light text-darken">{title}</p>
                    </div>
                    <img
                        src={`https://buiha.org.uk/assets/img/icon/150/${champions.gold_img}.png`}
                        alt={champions.gold_name}
                        className="mx-1 xs:max-sm:mx-2 sm:mx-4 inline object-cover w-10 h-10 md:w-12 md:h-12"
                    />
                </div>)}


            {nationals && champions.championship_name && (

                <div className="flex flex-row items-center justify-center">
                    <img
                        src={`https://buiha.org.uk/assets/img/icon/150/${champions.championship_img}.png`}
                        alt={champions.championship_name}
                        className="mx-1 xs:max-sm:mx-2 sm:mx-4 inline object-cover w-10 h-10 md:w-12 md:h-12"
                    />
                    <div className="flex flex-col items-center justify-center mx-2">
                        <p className="text-sm md:text-xl text-center">{champions.championship_name}</p>
                        <p className="text-xs text-center">{title}</p>
                    </div>
                    <img
                        src={`https://buiha.org.uk/assets/img/icon/150/${champions.championship_img}.png`}
                        alt={champions.championship_name}
                        className="mx-1 xs:max-sm:mx-2 sm:mx-4 inline object-cover w-10 h-10 md:w-12 md:h-12"
                    />
                </div>)}


            {nationals && champions.nationals_name && (

                <div className="flex flex-row items-center justify-center">
                    <img
                        src={`https://buiha.org.uk/assets/img/icon/150/${champions.nationals_img}.png`}
                        alt={champions.nationals_name}
                        className="mx-1 xs:max-sm:mx-2 sm:mx-4 inline object-cover w-10 h-10 md:w-12 md:h-12"
                    />
                    <div className="flex flex-col items-center justify-center mx-2">
                        <p className="text-sm md:text-xl text-center">{champions.nationals_name}</p>
                        <p className="text-xs text-center">{title}</p>
                    </div>
                    <img
                        src={`https://buiha.org.uk/assets/img/icon/150/${champions.nationals_img}.png`}
                        alt={champions.nationals_name}
                        className="mx-1 xs:max-sm:mx-2 sm:mx-4 inline object-cover w-10 h-10 md:w-12 md:h-12"
                    />
                </div>)}


            {nationals && champions.silver_name && (

                <div className="flex mt-0 flex-col md:flex-row items-center justify-center">
                    <div className="flex mt-2 flex-row items-center justify-center">
                        <img
                            src={`https://buiha.org.uk/assets/img/icon/150/${champions.silver_img}.png`}
                            alt={champions.silver_name}
                            className="xs:max-sm:mx-0.5 mx-1 inline object-cover w-6 h-6 md:w-8 md:h-8"
                        />
                        <div className="flex flex-col items-center justify-center mx-1">
                            <p className="text-xs md:text-smm text-center">
                                {champions.silver_name}
                            </p>
                            <p className="text-xxs text-center">Silver Playoff Winners</p>
                        </div>
                        <img
                            src={`https://buiha.org.uk/assets/img/icon/150/${champions.silver_img}.png`}
                            alt={champions.silver_name}
                            className="xs:max-sm:mx-0.5 mx-1 inline object-cover w-6 h-6 md:w-8 md:h-8"
                        />
                    </div>
                    {champions && champions.bronze_name && (
                        <div className="flex mt-2 flex-row items-center justify-center md:ml-8">
                            <img
                                src={`https://buiha.org.uk/assets/img/icon/150/${champions.bronze_img}.png`}
                                alt={champions.bronze_name}
                                className="xs:max-sm:mx-0.5 mx-1 inline object-cover w-6 h-6 md:w-8 md:h-8"
                            />
                            <div className="flex flex-col items-center justify-center mx-1">
                                <p className="text-xs md:text-smm text-center">
                                    {champions.bronze_name}
                                </p>
                                <p className="text-xxs text-center">Bronze Playoff Winners</p>
                            </div>
                            <img
                                src={`https://buiha.org.uk/assets/img/icon/150/${champions.bronze_img}.png`}
                                alt={champions.bronze_name}
                                className="xs:max-sm:mx-0.5 mx-1 inline object-cover w-6 h-6 md:w-8 md:h-8"
                            />
                        </div>
                    )}
                </div>
            )}


            {nationals && champions.quaich_name && (

                <div className="flex mt-0 flex-col md:flex-row items-center justify-center">
                    <div className="flex mt-2 flex-row items-center justify-center">
                        <img
                            src={`https://buiha.org.uk/assets/img/icon/150/${champions.quaich_img}.png`}
                            alt={champions.quaich_name}
                            className="xs:max-sm:mx-0.5 mx-1 inline object-cover w-6 h-6 md:w-8 md:h-8"
                        />
                        <div className="flex flex-col items-center justify-center mx-1">
                            <p className="text-xs md:text-smm text-center">
                                {champions.quaich_name}
                            </p>
                            <p className="text-xxs text-center">Quaich Playoff Winners</p>
                        </div>
                        <img
                            src={`https://buiha.org.uk/assets/img/icon/150/${champions.quaich_img}.png`}
                            alt={champions.quaich_name}
                            className="xs:max-sm:mx-0.5 mx-1 inline object-cover w-6 h-6 md:w-8 md:h-8"
                        />
                    </div>
                    {champions && champions.bowl_name && (
                        <div className="flex mt-2 flex-row items-center justify-center md:ml-8">
                            <img
                                src={`https://buiha.org.uk/assets/img/icon/150/${champions.bowl_img}.png`}
                                alt={champions.bowl_name}
                                className="xs:max-sm:mx-0.5 mx-1 inline object-cover w-6 h-6 md:w-8 md:h-8"
                            />
                            <div className="flex flex-col items-center justify-center mx-1">
                                <p className="text-xs md:text-smm text-center">
                                    {champions.bowl_name}
                                </p>
                                <p className="text-xxs text-center">Bowl Playoff Winners</p>
                            </div>
                            <img
                                src={`https://buiha.org.uk/assets/img/icon/150/${champions.bowl_img}.png`}
                                alt={champions.bowl_name}
                                className="xs:max-sm:mx-0.5 mx-1 inline object-cover w-6 h-6 md:w-8 md:h-8"
                            />
                        </div>
                    )}
                </div>
            )}
        </div>
    </div>
  );
};

export default DivisionInfo;
